import script from "./TaxonomyTree.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxonomyTree.vue?vue&type=script&setup=true&lang=js"

import "./TaxonomyTree.vue?vue&type=style&index=0&id=0dfd5603&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dfd5603"]])

export default __exports__